import { render, staticRenderFns } from "./elp.vue?vue&type=template&id=2bcf0c70"
import script from "./elp.vue?vue&type=script&lang=ts"
export * from "./elp.vue?vue&type=script&lang=ts"
import style0 from "./elp.vue?vue&type=style&index=0&id=2bcf0c70&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports